//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history/Early_Modern_Period_-_European_Maritime_Empires.png';

const subTopics = [
  { name: 'European Maritime Empires', route: '/History-European-Maritime-Empires', key: 'European Maritime Empires' },
  { name: 'Columbian Exchange', route: '/History-Columbian-Exchange', key: 'Columbian Exchange' },
  { name: 'Spanish and Portuguese Colonization', route: '/History-Spanish-Portuguese-Colonization', key: 'Spanish and Portuguese Colonization' },
  { name: 'Ottoman Empire', route: '/History-Ottoman-Empire', key: 'Ottoman Empire' },
  { name: 'Ming and Qing Dynasties (China)', route: '/History-Ming-Qing-Dynasties', key: 'Ming and Qing Dynasties (China)' },
  { name: 'Aztec and Inca Empires', route: '/History-Aztec-Inca-Empires', key: 'Aztec and Inca Empires' }
];

function HistoryPageEM() {
  return (
    <JourneyPage
      title="Early Modern"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageEM;
